module.exports = __webpack_public_path__ + "img/house-in-allotment-1.797356ce.jpg";